import { guid } from '../util/helpers'

const fields = {
  basic: []
}

function seed () {
  const basic = [
    { name: 'Full name', type: 'text', value: '' },
    { name: 'Job title', type: 'text', value: '' },
    { name: 'Location', type: 'text', value: '' },
    { name: 'Website', type: 'text', value: '' },
    { name: 'Email', type: 'text', value: '' },
    { name: 'Phone', type: 'text', value: '' },
    { name: 'Address', type: 'text', value: '' },
    { name: 'Footer', type: 'text', value: '' }
  ]

  basic.forEach(item => {
    fields.basic.push({ ...item, id: guid() })
  })

  addPlaceholder()
}

function addPlaceholder () {
  const placeholders = [
    'John Doe',
    'Manager',
    'Amsterdam',
    'abbeyroadinstitute.com',
    'mail@abbeyroadinstitute.com',
    '+ 1 123 456 7890',
    '3 Abbey Rd, London NW8 9AY, UK',
    'Abbey Road Institute is a trading name of Abbey Road Training Limited, a limited company, registered in England and Wales, registered number 09201312. Registered Office: 4 Pancras Square, London N1C 4AG<br><br>This email (including all attachments) is confidential and may be subject to legal privilege and/or copyright. The information contained within this email (including all attachments) should only be viewed if you are the intended recipient. If you have received this email in error, please notify the sender immediately and delete this email from your system along with any copies that have been made. Any unauthorised use, which includes saving, printing, copying, disseminating or forwarding is prohibited and may result in breach of confidentiality, privilege or copyright.'
  ]

  fields.basicPlaceholder = [
    ...fields.basic.map((item, index) => {
      return { ...item, value: placeholders[index] }
    })
  ]
}

seed()

export default fields
